"use strict";
/*
 * Created on 1. 4. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ObjectUtils_1 = require("../../../core/utils/ObjectUtils");
/**
 * Product - site - release key.
 * @author Radek Beran
 */


var ProductSiteReleaseKey =
/*#__PURE__*/
function () {
  function ProductSiteReleaseKey(productId, siteId, releaseId) {
    _classCallCheck(this, ProductSiteReleaseKey);

    this.productId = productId;
    this.siteId = siteId;
    this.releaseId = releaseId;
  }

  _createClass(ProductSiteReleaseKey, [{
    key: "equals",
    value: function equals(other) {
      if (other instanceof ProductSiteReleaseKey) {
        var otherKey = other;
        return this.productId === otherKey.productId && this.siteId === otherKey.siteId && this.releaseId === otherKey.releaseId;
      } else {
        return false;
      }
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.productId + '-' + this.siteId + '-' + this.releaseId);
    }
  }]);

  return ProductSiteReleaseKey;
}();

exports.ProductSiteReleaseKey = ProductSiteReleaseKey;